<template>
  <pack>
    <zt-title>帮助管理</zt-title>
    <div class="menu-box">
      <div class="left">
        <div class="title">帮助中心列表</div>
        <div class="list" ref="menuList">
          <el-tree
            :data="list"
            node-key="id"
            :props="defaultProps"
            :expand-on-click-node="false"
            default-expand-all
            :current-node-key="1"
            highlight-current
            @node-click="handleNodeClick"
            ref="menu"
          >
            <div
              slot-scope="{ node, data }"
              :ref="`tree_${node.id}`"
              :class="chooseNodeId==node.id?'active':''"
            >
              <span>{{data.title}}</span>
              <span class="icon" @click.stop="addMenu(node)" v-if="data.cat_id==0">
                <svg-icon icon="ic_add"></svg-icon>
              </span>
            </div>
          </el-tree>
        </div>
        <div class="add-menu">
          <div class="add-box" @click="addfristLevMenu">
            <svg-icon icon="icon_zhankai_p"></svg-icon>
            <span>新增菜单</span>
          </div>
        </div>
      </div>
      <div class="right">
        <template v-if="menuData.id">
          <zt-title>
            {{menuData.title}}
            <i class="el-icon-delete" @click="delMenu"></i>
          </zt-title>
          <div class="edit-menu">
            <span class="title">{{menuData.cat_id==0?'一级菜单名':'二级菜单名'}}</span>
            <zt-input placeholder="请输入一级菜单名" v-model="menuData.title"></zt-input>
            <zt-button @click="saveMenu">保存</zt-button>
          </div>
          <template v-if="!(menuData.lsList && menuData.lsList.length > 0)">
            <zt-button type="primary" class="add-btn" @click="addArticle">添加文章</zt-button>
            <template v-if="articleList.length>0">
              <div class="article-list">
                <div class="article" v-for="item in articleList" :key="item.id+item.ls_id">
                  <app-link
                    :to="`/helpManage/helpArticle/${item.ls_id}_${item.id}_${encodeURIComponent(item.title)}`"
                  >{{item.title}}</app-link>
                  <div class="icon-box">
                    <svg-icon icon="textEdit" class="icon" @click="editArticle(item)"></svg-icon>
                    <i class="el-icon-delete icon" @click="delArticle(item)"></i>
                  </div>
                </div>
              </div>
              <div class="pagination mt24">
                <el-pagination
                  @size-change="onPageSizeChange"
                  @current-change="onPageChange"
                  :current-page="form.page"
                  :page-sizes="[10, 20, 30, 40]"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="recordcount"
                  :page-size="form.pagesize"
                />
              </div>
            </template>
          </template>
        </template>
      </div>
    </div>
  </pack>
</template>

<script>
import {
  admin_help_menu_list,
  admin_help_article_list,
  admin_help_menu_add,
  admin_help_menu_edit,
  admin_help_menu_delete,
  admin_help_article_delete
} from '@/api/helpManage';
export default {
  name: 'helpManage',
  data: () => ({
    chooseNodeId: 1,
    list: [],
    articleList: [],
    defaultProps: {
      children: 'lsList',
      label: 'title',
    },
    form: {
      page: 1,
      pagesize: 10,
      ls_id: '',
    },
    recordcount: 0,
    menuData: {},
  }),
  methods: {
    encodeURIComponent: window.encodeURIComponent,
    //保存菜单
    async saveMenu() {
      const { data } = await admin_help_menu_edit(this.menuData);
      if (data.error_code == 0) {
        this.$message.success('保存菜单成功');
      } else {
        this.$message.error(data.error_message);
      }
    },

    //删除菜单
    async delMenu() {
      this.$confirm(`确认删除${this.menuData.title}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async() => {
        const { data } = await admin_help_menu_delete({
          id: this.menuData.id,
        });
        if (data.error_code == 0) {
          this.$message.success('删除菜单成功');
          // this.$refs.menu.remove(this.menuData.id);
          this.list.map((arr, idx) => {
            if (this.menuData.id == arr.id) {
              this.list.splice(idx, 1);
            } else if (arr.lsList && arr.lsList.length > 0) {
              arr.lsList.map((lsItem, lsIdx) => {
                if (lsItem.id == this.menuData.id) {
                  arr.lsList.splice(lsIdx, 1);
                }
              });
            }
          });
          if (this.list.length == 0) {
            this.menuData = '';
            return;
          }
          this.menuData = this.list[0];
          this.chooseNodeId = this.menuData.$treeNodeId;
          this.getArticleList();
        } else {
          this.$message.error(data.error_message);
        }
      });
    },

    // 分页器页面大小改变
    onPageSizeChange(pagesize) {
      this.form.pagesize = pagesize;
      // 当前页数*当前页面大小 > 数据总数 的时候不发请求(由onPageChange发请求)
      if (this.form.page * pagesize > this.recordcount && this.form.page != 1)
        return;
      // 发请求
      this.getArticleList();
    },

    // 分页器页数改变
    onPageChange(page) {
      this.form.page = page;
      this.getArticleList();
    },

    //获取菜单文章列表
    async getArticleList() {
      if (
        (this.menuData.lsList && this.menuData.lsList.length > 0) ||
        !this.menuData.id
      )
        return;
      this.form.ls_id = this.menuData.id;
      const { data } = await admin_help_article_list(this.form);
      if (data.error_code == 0) {
        this.articleList = data.list;
        this.recordcount = data.recordcount;
      } else {
        this.$message.error(data.error_message);
      }
    },

    //获取菜单列表
    async getMenuList(chooseDefault = true) {
      const { data } = await admin_help_menu_list();
      if (data.error_code == 0) {
        this.list = data.list;
        if (this.list.length == 0) return;
        this.list.map((arr, idx) => {
          arr.idx = idx;
        });
        if (chooseDefault) {
          this.menuData = data.list[0];
        }
        if (
          !(this.menuData.lsList && this.menuData.lsList.length > 0) &&
          this.menuData.id
        ) {
          this.getArticleList();
        }
      } else {
        this.$message.error(data.error_message);
      }
    },

    //增加文章
    addArticle() {
      this.$router.push(`/helpManage/helpArticle/${this.menuData.id}_add`);
    },

    //删除文章
    async delArticle(item) {
      this.$confirm(`确认删除${item.title}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async() => {
        const { data } = await admin_help_article_delete(item);
        if (data.error_code == 0) {
          this.$message.success('删除文章成功');
          this.getArticleList();
        } else {
          this.$message.error(data.error_message);
        }
      });
    },

    //编辑
    editArticle(item) {
      this.$router.push(
        `/helpManage/helpArticle/${item.ls_id}_${item.id}_${item.title}`
      );
    },

    //添加一级菜单
    async addfristLevMenu() {
      const { data } = await admin_help_menu_add({
        title: '一级菜单',
        cat_id: 0,
      });
      if (data.error_code == 0) {
        this.articleList = [];

        if (this.list.length > 0) {
          this.$refs.menu.insertAfter(
            {
              id: data.info[0],
              title: '一级菜单',
              lsList: [],
              cat_id: 0,
              idx: this.list.length,
            },
            this.list.slice(-1)[0]
          );
        } else {
          this.$refs.menu.append(
            {
              id: data.info[0],
              title: '一级菜单',
              lsList: [],
              cat_id: 0,
              idx: this.list.length,
            },
            this.list.slice(-1)[0]
          );
        }
        const newNode = this.list.slice(-1)[0];
        //切换到新增菜单
        this.chooseNodeId = newNode.$treeNodeId;
        this.menuData = newNode;
        this.menuData.id = data.info[0];
        this.$nextTick(() => {
          this.$refs.menuList.scrollTop = 99999;
        });
      } else {
        this.$message.error(data.error_message);
      }
    },

    //添加子菜单
    addMenu(node) {
      const { data } = node;
      //一级菜单 有子菜单 直接添加子菜单
      if (data.lsList && data.lsList.length > 0) {
        this.articleList = [];
        this.list.map(async(arr) => {
          if (arr.id == data.id && arr.idx == data.idx) {
            let res = await admin_help_menu_add({
              title: '二级菜单',
              cat_id: data.id,
            });
            res = res.data;
            if (res.error_code == 0) {
              this.$refs.menu.append(
                {
                  id: '',
                  title: '二级菜单',
                  cat_id: data.id,
                },
                node
              );
              const newNode = node.data.lsList.slice(-1)[0];
              //切换到新增菜单
              this.chooseNodeId = newNode.$treeNodeId;
              this.menuData = newNode;
              this.menuData.id = res.info[0];
              this.$nextTick(() => {
                //二级列表不可见则执行滚动
                let nodeTop = this.$refs[
                  `tree_${newNode.$treeNodeId}`
                ].getBoundingClientRect().top;
                let menuListTop = this.$refs.menuList.getBoundingClientRect()
                  .top;
                let menuListHeight = this.$refs.menuList.getBoundingClientRect()
                  .height;
                if (nodeTop > menuListTop + menuListHeight) {
                  this.$refs.menuList.scrollTop =
                    this.$refs.menuList.scrollTop +
                    nodeTop -
                    (menuListTop + menuListHeight) +
                    60;
                }
              });
            } else {
              this.$message.error(res.error_message);
            }
          }
        });
      } else {
        //一级菜单无子菜单 提示会把菜单下文章删除
        this.$confirm(
          '添加二级菜单默认删除对应一级菜单下的所有文章',
          '是否添加二级菜单',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }
        ).then(() => {
          this.articleList = [];
          this.list.map(async(arr) => {
            if (arr.id == data.id && arr.idx == data.idx) {
              let res = await admin_help_menu_add({
                title: '二级菜单',
                cat_id: data.id,
              });
              res = res.data;
              if (res.error_code == 0) {
                this.$refs.menu.append(
                  {
                    id: '',
                    title: '二级菜单',
                    cat_id: data.id,
                  },
                  node
                );
                const newNode = node.data.lsList.slice(-1)[0];
                //切换到新增菜单

                this.chooseNodeId = newNode.$treeNodeId;
                this.menuData = newNode;
                this.menuData.id = res.info[0];
                this.$nextTick(() => {
                  //二级列表不可见则执行滚动
                  let nodeTop = this.$refs[
                    `tree_${newNode.$treeNodeId}`
                  ].getBoundingClientRect().top;
                  let menuListTop = this.$refs.menuList.getBoundingClientRect()
                    .top;
                  let menuListHeight = this.$refs.menuList.getBoundingClientRect()
                    .height;
                  if (nodeTop > menuListTop + menuListHeight) {
                    this.$refs.menuList.scrollTop =
                      this.$refs.menuList.scrollTop +
                      nodeTop -
                      (menuListTop + menuListHeight) +
                      60;
                  }
                });
              } else {
                this.$message.error(data.error_message);
              }
            }
          });
        });
      }
    },

    handleNodeClick(data) {
      if (this.list.length == 0) return;
      this.chooseNodeId = data.$treeNodeId;
      this.menuData = data;
      //菜单无子菜单才去加载文章列表 且不是新增
      if (!(data.lsList && data.lsList.length > 0) && data.id != '') {
        this.getArticleList();
      }
    },
  },
  activated() {
    this.getArticleList();
  },
  async mounted() {
    await this.getMenuList();
  },
};
</script>

<style lang="scss" scoped>
.menu-box {
  display: flex;
  border-radius: 4px;
  border: 1px solid rgba(235, 238, 245, 1);
  .left {
    border: 1px solid rgba(235, 238, 245, 1);
    border-width: 0 1px 0 0;
    flex: none;
    width: 184px;
    .title {
      height: 44px;
      width: 100%;
      background: rgba(250, 242, 252, 1);
      box-sizing: border-box;
      padding: 14px 20px;
      font-size: 12px;
      color: rgba(141, 146, 153, 1);
      line-height: 17px;
    }
    .list {
      overflow-y: auto;
      max-height: 500px;
      padding-left: 20px;
      /deep/ .el-tree-node__children {
        overflow: visible;
      }
      /deep/ .el-tree-node__content {
        overflow: visible;
        position: relative;
        font-size: 14px;
        height: 44px;
        background: rgba(255, 255, 255, 1);
        font-weight: 600;
        .icon {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translate(0, -50%);
          font-size: 19px;
        }
        .active {
          color: #B27DFF;
          &::before {
            content: "";
            display: block;
            position: absolute;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 6px;
            border-color: transparent transparent transparent #B27DFF;
            left: -20px;
            top: 50%;
            transform: translate(0, -50%);
          }
        }
        &:hover {
          color: #B27DFF;
        }
      }
      /deep/ .el-tree-node__expand-icon {
        display: none;
      }
    }
    .add-menu {
      text-align: center;
      color: #B27DFF;
      font-size: 12px;
      line-height: 17px;
      vertical-align: middle;
      height: 44px;
      line-height: 44px;
      padding: 0px 12px;
      margin-bottom: 40px;
      .add-box {
        cursor: pointer;
        border: 1px solid rgba(235, 238, 245, 1);
        border-width: 1px 0 0 0;
        .svg-icon {
          font-size: 17px;
        }
      }
      span {
        text-decoration: underline;
        margin-left: 3px;
        cursor: pointer;
      }
      .svg-icon {
        font-size: 19px;
        fill: #B27DFF;
        vertical-align: middle;
      }
    }
  }
  .right {
    flex: 1;
    padding: 12px 31px;
    /deep/ .zt-title {
      i {
        float: right;
        color: #8d9299;
        margin-top: 13px;
      }
    }
    .edit-menu {
      margin-top: 24px;
      padding-bottom: 16px;
      border-style: solid;
      border-color: #f7f2ff;
      border-width: 0 0 1px 0;
    }
    /deep/ .zt-input {
      width: 285px;
      margin-right: 16px;
      display: inline-block;
    }
    .title {
      font-size: 14px;
      font-weight: 600;
      color: #232526;
      line-height: 20px;
      margin-right: 12px;
    }
    /deep/ .zt-button {
      width: 92px;
      height: 40px;
    }
    .add-btn {
      margin-top: 16px;
      width: 143px;
      height: 40px;
      border-radius: 2px;
    }
    .article-list {
      max-height: 428px;
      overflow-y: auto;
      margin-top: 16px;
      border-style: solid;
      border-width: 1px 0 0 0;
      border-color: #f2f6fc;
      .article {
        display: block;
        height: 54px;
        padding: 16px 0;
        border-style: solid;
        border-width: 0 0 1px 0;
        border-color: #f2f6fc;
      }
      .app-link {
        color: #232526;
        font-size: 16px;
        line-height: 22px;
        transition: all 0.2s;
        &:hover {
          color: #B27DFF;
        }
      }
      .icon-box {
        float: right;
        color: #8d9299;
        font-size: 18px;
        .svg-icon {
          cursor: pointer;
          margin-right: 24px;
        }
        i {
          cursor: pointer;
        }
      }
    }
  }
}
/deep/ .el-tree__empty-block {
  margin-left: -10px;
}
.pagination {
  text-align: right;
}
/* 滚动条样式 */
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 5px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background: #d8d8d8;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  border-radius: 10px;
  background: #f9f9f9;
}
</style>
